import { initAcTooltips } from "../plugin/tooltip";
class Tooltips {
    constructor() {
        this.init();
    }
    init() {
        initAcTooltips();
    }
}
export default Tooltips;
